import {PALLET_COMMITS} from '@/store/contracts'

const state = {
    messages:[],
    notifications:[],
    loading:{},
    tray:{},
    console:{}
}
const getters={
    isShowTray(state) {
        for (const key in state.tray) {
            const actions = state.tray[key]
            if(actions && actions.length){
               return true 
            }            
        }
        return false
    }
}
const mutations = {
    [PALLET_COMMITS.ADD_TRAY]: (state, {key,actions})=>{
        if(!Array.isArray(actions)){
            actions = [actions]
        }
        if(!state.tray[key]){
            state.tray[key] = actions
        }else if(!state.tray[key].actions){
            state.tray[key].actions = actions
        }else{
            Object.assign(state.tray[key].actions, actions)
        }
        
    },
    [PALLET_COMMITS.REMOVE_TRAY]: (state, key)=>{
        delete state.tray[key]
    }
}
export default {
    namespaced: true,
    state,
    getters,
    mutations
}